import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { GutachtenService, GutachtensService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [GutachtenService, GutachtensService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class GutachtenServiceModule {}
